var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 46,
    viewBox: "0 0 58 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43218 45.397C-0.477394 45.397 -0.477394 42.4937 1.43218 42.4937H10.1851V32.9788C10.1851 31.0699 13.0884 31.0699 13.0884 32.9788V42.4937H21.7605V24.221C21.7605 22.3121 24.6639 22.3121 24.6639 24.221V42.4937H33.336V26.2774C33.336 24.3685 36.2393 24.3685 36.2393 26.2774V42.4937H44.9114V4.95455C44.9114 3.04497 47.8148 3.04497 47.8148 4.95455V42.4937H56.5683C58.4772 42.4937 58.4772 45.397 56.5683 45.397C38.1896 45.397 19.8109 45.397 1.43218 45.397ZM40.0465 0.94156L41.4624 4.40956C42.1787 6.17727 39.491 7.26585 38.7747 5.49814L38.571 4.9981L31.6933 19.0717C31.2782 19.9222 30.1538 20.1574 29.4346 19.5211L21.6952 12.6919L11.2989 27.5626C10.211 29.1189 7.84075 27.4636 8.92863 25.9065L20.2534 9.70918C20.7492 8.99915 21.75 8.88397 22.3961 9.45425L29.9227 16.0953L35.9022 3.85263L35.3727 4.01978C33.5523 4.59357 32.68 1.82647 34.4997 1.25268L38.2528 0.0671853C38.9882 -0.163874 39.7761 0.218884 40.0465 0.94156Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphUpIcon);
export default __webpack_public_path__ + "static/media/GraphUpIcon.37e3f27a054faa5702a21040cbafe4fa.svg";
export { ForwardRef as ReactComponent };